export const ProfileAvatars: { [key: string]: any } = {
  // Currently available avatars
  "01": require("./Profile/01.png"),
  "02": require("./Profile/02.png"),
  "03": require("./Profile/03.png"),
  "04": require("./Profile/04.png"),
  "05": require("./Profile/05.png"),
  "06": require("./Profile/06.png"),
  "07": require("./Profile/07.png"),
  "08": require("./Profile/08.png"),
  "09": require("./Profile/09.png"),
  "10": require("./Profile/10.png"),
  "11": require("./Profile/11.png"),
  "12": require("./Profile/12.png"),
  "13": require("./Profile/13.png"),
  "14": require("./Profile/14.png"),
  "15": require("./Profile/15.png"),
  "16": require("./Profile/16.png"),
  "17": require("./Profile/17.png"),
  "18": require("./Profile/18.png"),

  // Legacy avatars
  "01_avatar_animal": require("./Profile/legacy/01_avatar_animal.png"),
  "01_avatar_female": require("./Profile/legacy/01_avatar_female.png"),
  "01_avatar_male": require("./Profile/legacy/01_avatar_male.png"),
  "02_avatar_animal": require("./Profile/legacy/02_avatar_animal.png"),
  "02_avatar_female": require("./Profile/legacy/02_avatar_female.png"),
  "02_avatar_male": require("./Profile/legacy/02_avatar_male.png"),
  "03_avatar_animal": require("./Profile/legacy/03_avatar_animal.png"),
  "03_avatar_female": require("./Profile/legacy/03_avatar_female.png"),
  "03_avatar_male": require("./Profile/legacy/03_avatar_male.png"),
  "04_avatar_animal": require("./Profile/legacy/04_avatar_animal.png"),
  "04_avatar_female": require("./Profile/legacy/04_avatar_female.png"),
  "04_avatar_male": require("./Profile/legacy/04_avatar_male.png"),
  "05_avatar_animal": require("./Profile/legacy/05_avatar_animal.png"),
  "05_avatar_female": require("./Profile/legacy/05_avatar_female.png"),
  "05_avatar_male": require("./Profile/legacy/05_avatar_male.png"),
  "06_avatar_animal": require("./Profile/legacy/06_avatar_animal.png"),
  "06_avatar_female": require("./Profile/legacy/06_avatar_female.png"),
  "06_avatar_male": require("./Profile/legacy/06_avatar_male.png"),
  "07_avatar_animal": require("./Profile/legacy/07_avatar_animal.png"),
  "07_avatar_female": require("./Profile/legacy/07_avatar_female.png"),
  "07_avatar_male": require("./Profile/legacy/07_avatar_male.png"),
  "08_avatar_animal": require("./Profile/legacy/08_avatar_animal.png"),
  "08_avatar_female": require("./Profile/legacy/08_avatar_female.png"),
  "08_avatar_male": require("./Profile/legacy/08_avatar_male.png"),
  "09_avatar_animal": require("./Profile/legacy/09_avatar_animal.png"),
  "09_avatar_female": require("./Profile/legacy/09_avatar_female.png"),
  "09_avatar_male": require("./Profile/legacy/09_avatar_male.png"),
  "10_avatar_female": require("./Profile/legacy/10_avatar_female.png"),
  "10_avatar_male": require("./Profile/legacy/10_avatar_male.png"),
  "11_avatar_female": require("./Profile/legacy/11_avatar_female.png"),
  "11_avatar_male": require("./Profile/legacy/11_avatar_male.png"),
  profile_avatar_1: require("./Profile/legacy/01_profile_picture.png"),
  profile_avatar_2: require("./Profile/legacy/02_profile_picture.png"),
  profile_avatar_3: require("./Profile/legacy/03_profile_picture.png"),
  profile_avatar_4: require("./Profile/legacy/04_profile_picture.png"),
  profile_avatar_5: require("./Profile/legacy/05_profile_picture.png"),
  profile_avatar_6: require("./Profile/legacy/06_profile_picture.png"),
  profile_avatar_7: require("./Profile/legacy/07_profile_picture.png"),
  profile_avatar_8: require("./Profile/legacy/08_profile_picture.png"),
  profile_avatar_9: require("./Profile/legacy/09_profile_picture.png"),
  profile_avatar_10: require("./Profile/legacy/10_profile_picture.png"),
  profile_avatar_11: require("./Profile/legacy/11_profile_picture.png"),
  profile_avatar_12: require("./Profile/legacy/12_profile_picture.png"),
  profile_avatar_13: require("./Profile/legacy/13_profile_picture.png"),
  profile_avatar_14: require("./Profile/legacy/14_profile_picture.png"),
  profile_avatar_16: require("./Profile/legacy/16_profile_picture.png"),
  profile_avatar_17: require("./Profile/legacy/17_profile_picture.png"),
  profile_avatar_18: require("./Profile/legacy/18_profile_picture.png"),
  profile_avatar_19: require("./Profile/legacy/19_profile_picture.png"),
  profile_avatar_20: require("./Profile/legacy/20_profile_picture.png"),
}
